/**
 * Yjs 事务来源标记。
 *
 * 这里只放系统过程态使用的 origin。用户可见操作继续使用默认 origin，
 * 这样可以复用现有 UndoManager 规则，不引入第二套 undo/redo 体系。
 */

/**
 * task 生命周期同步来源。
 *
 * 用于标记 `status`、`runId`、任务缓存清理等过程态写入；这些写入不应进入用户 undo 历史。
 */
export const YJS_TASK_LIFECYCLE_ORIGIN = Symbol('task-lifecycle');
